import {useQuery} from 'react-query';
import { PostEditDetail } from 'services/farm/advertisement/add';

const usePostEditDetail = (guid: string) => {
  const {data: postEditDetail, isLoading} = useQuery(
    ['post-edit-detail', guid],
    PostEditDetail,
  );
  return {postEditDetail, isLoading};
};

export default usePostEditDetail;
